import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const length = this.element.value.length;
    if (length === 0) return
    this.element.focus();
    this.element.setSelectionRange(length, length);
  }
}
